export default __webpack_public_path__ + "static/media/9608FEA4-8562-4610-8B54-CCC372E65D66_1_105_c.dcbd179f.jpeg";